<template>
  <form autocomplete="off" >
    <div class="md-autocomplete-loading" v-show="isPromisePending">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <!-- <CrudToolbar :save="saveFunc" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancelFunc"></CrudToolbar>-->

    <div class="md-layout">

        <div v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                   :x="slot.layout.x"
                   :y="slot.layout.y"
                   :w="slot.layout.w"
                   :h="slot.layout.h"
                   :i="slot.layout.i"
                   :key="'griditem_'+ slotName + slot.layout.i"
        >

          <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content md-layout-item md-xsmall-size-100 md-size-50 md-medium-size-50 md-large-size-25">
            <h3>{{slot.label}}</h3>Create a base record to enable this section.
          </div>

          <div v-else :key="slotName">
            
            <h3 v-if="slot.label && slot.isLabelEnabled" :id="slot.id"><span class="heading">{{slot.label}}</span></h3>

            <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

              <CrudCheckbox
                v-if="field.type == 'checkbox'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

              <CrudSearchModal
                v-else-if="field.type == 'searchmodal'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="filter"></CrudSearchModal>

              <CrudSearchModalParentChild
                v-else-if="field.type == 'parentchild'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="filter"></CrudSearchModalParentChild>

              <CrudDatepicker
                v-else-if="field.type == 'datepicker'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

              <CrudSelect
                v-else-if="field.type == 'select'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

              <CrudAutocomplete
                v-else-if="field.type == 'autocomplete'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

              <CrudJson
                v-else-if="field.type == 'json'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

              <CrudSwitch
                v-else-if="field.type == 'switch'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>

              <!--
              <CrudText
                v-else :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.formConfig.fields" :field.sync="field"></CrudText>
                -->
              <CrudId
                v-else-if="field.type == 'id'" :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

              <!-- ATLAS-532: Add Notes Field - Richtext editor -->
              <CrudTextEditor
                v-else-if="field.type == 'textEditor'" :key="name" :name="name"
                :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"
              ></CrudTextEditor>

              <!-- ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New -->
              <CrudListControl
                v-else-if="field.type == 'listControl'" :key="name" :name="name"
                :form="form" :pageMode="formConfig.pageMode" :field.sync="field" 
                :items="accountServiceItems" @selectedServices="onSelectedServices" @isShowLoader="isShowLoader"
              ></CrudListControl>

              <CrudText
                v-else :key="name"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>
            </template>

          </div>
        </div>

    </div>
    <slot></slot>

    <!-- <CrudToolbar :save="saveFunc" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancelFunc"></CrudToolbar>-->
  </form>
</template>

<script>
  import RecordForm from '@/mixins/RecordForm';

  export default {
    name: "basic-form",
    mixins: [RecordForm],
    props: {
      cancelFunc: {
        type: Function,
        required: true
      },
      saveFunc: {
        type: Function,
        required: true
      }
    },
  };
</script>

<style lang="scss">
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {

    .md-toolbar.md-transparent {
      background-color: #FFF !important;
    }

    &.md-warning {
      background-color: #e57373;

      .md-toolbar.md-transparent {
        background-color: #FFF !important;
      }

    }

    .form-field-view {
      overflow-wrap: break-word;
    }

    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    .vue-grid-item-content {
      display: flex;
      flex-wrap: wrap;
      background-color: #FFF;
      padding-left: 0;
    }

    .field {
      width: 50%;
      float: left;
      padding-right: 30px;
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

  .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }
</style>
